import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Button, Alert, FormGroup, FormControl, ControlLabel, Modal, } from 'react-bootstrap';
import validator from 'email-validator';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class SendDOEmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.send = () => {
            const emails = this.state.to.replace(/' '/g, '').split(',');
            const invalidEmailAddresses = emails.filter((ea) => !validator.validate(ea));
            if (invalidEmailAddresses.length > 0) {
                this.setState({ error: 'VALID_EMAIL_ONLY' });
                return;
            }
            this.props.onSend(_.uniq(emails));
            this.setState(this.getInitialState());
            this.props.onHide();
        };
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            error: null,
            to: this.props.defaultRecipient,
        };
    }
    componentWillUnmount() {
        this.setState(this.getInitialState());
    }
    addRecipients(e) {
        this.setState({ to: e.target.value.trim() });
    }
    renderError() {
        const { t } = this.props;
        if (!this.state.error) {
            return '';
        }
        return React.createElement(Alert, { bsStyle: "warning" }, t(this.state.error));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide, enforceFocus: false },
            React.createElement(Modal.Header, null,
                React.createElement("strong", null, t('EMAIL_DELIVERY_ORDER'))),
            React.createElement(Modal.Body, null,
                this.renderError(),
                React.createElement("div", null,
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('RECIPIENT', { count: 1 }))),
                        React.createElement(FormControl, { placeholder: t('COMMA_SEPARATED_EMAILS'), onChange: (e) => this.addRecipients(e), type: "text", value: this.state.to })))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { type: "button", onClick: this.props.onHide }, titleize(t('CLOSE'))),
                React.createElement(Button, { disabled: this.state.to === '', bsStyle: "primary", type: "button", onClick: this.send }, t('SEND')))));
    }
}
SendDOEmailModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    defaultRecipient: PropTypes.string,
};
export default withTranslation()(SendDOEmailModal);
